import {
  makeStyles,
  MessageBar,
  MessageBarBody,
  MessageBarGroup,
  MessageBarTitle,
  tokens,
} from "@fluentui/react-components";
import {
  DEFAULT_MAP_ERROR,
  MAP_ERROR_CONFIG,
  MapErrorId,
} from "../../utils/maps/MapConstants";

export interface IDisplayMapErrorsProps {
  messages: string[];
}

export default function DisplayMapErrors({ messages }: IDisplayMapErrorsProps) {
  const styles = useStyles();

  if (!messages.length) {
    return null;
  }

  return (
    <MessageBarGroup animate={"both"} className={styles.messageBarGroup}>
      {messages.map((id) => {
        const config = MAP_ERROR_CONFIG[id as MapErrorId] ?? DEFAULT_MAP_ERROR;

        return (
          <MessageBar key={id} intent={"error"}>
            <MessageBarBody>
              <MessageBarTitle>{config.errorMessage}</MessageBarTitle>
              {config.retryMessage}
            </MessageBarBody>
          </MessageBar>
        );
      })}
    </MessageBarGroup>
  );
}

const useStyles = makeStyles({
  messageBarGroup: {
    padding: tokens.spacingHorizontalMNudge,
    display: "flex",
    flexDirection: "column",
    marginTop: "3px",
    alignItems: "flex-end",
    gap: "10px",
    position: "relative",
    right: "180px",
    zIndex: 1000,
  },
});
